<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button routerDirection="back"></ion-back-button>
      <ion-menu-button class="ionMenuButtonCls" autoHide="true"></ion-menu-button>
    </ion-buttons>
    <ion-title>Help</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="padding">
  <h2 class="padding"> Offline Help Center</h2>
  <p class="padding"> For more help resources and live support go to our <span (click)="openSupport()"
      class="link">Support Section.</span></p>
  <ion-card class="accordion-list">
    <div *ngFor="let d of faqs">
      <ion-item class="btn-faq ion-text-wrap" (click)="toggleDetails(d)" [ngClass]="{'section-active': d.showDetails}">
        <p class="ion-text-wrap">
          {{d.question}}
        </p>
        <ion-icon slot="end" name="chevron-down-outline" *ngIf="!d.showDetails"></ion-icon>
        <ion-icon slot="end" name="chevron-up-outline" *ngIf="d.showDetails"></ion-icon>
      </ion-item>
      <div class="child-item" *ngIf="d.showDetails" [innerHTML]="d.answer">
      </div>
    </div>
  </ion-card>

  <div class="spacer-26"></div>

  <ion-row class="centerText padding">
    <ion-col size="col-4">
      <a ui-sref="#" (click)="blockparty()">Curb Hero Website </a>
    </ion-col>
    <ion-col size="col-4">
      <a ui-sref="#" (click)="terms()">
        <!-- Terms and Conditions -->
      </a>
    </ion-col>
    <ion-col col-4>
      <span class="appVersionSpan">{{env.appversion}}</span>
    </ion-col>
  </ion-row>

  <div class="spacer-52"></div>

</ion-content>